import '../../admin-shared.css'

import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { useNavigate } from 'react-router-dom'

import { PageHeader, Spinner } from '../../../../Components'
import { useCQuery } from '../../../../Services/QueryCache'
import { cap } from '../../../../State'
import { translations } from '../../../../translations'
import { actionsColumnProps, columnProps } from '../../../Prompts/Functions'
import { AdminTableActions } from '../../Components/AdminTableActions'
import { deleteTraveller } from '../Editor/Functions'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

export function TravellersList() {
  const { data: travellers = [], isSuccess } = useCQuery(['travellers'])
  const navigate = useNavigate()

  if (!isSuccess) return <Spinner />

  return (
    <>
      <PageHeader
        title={t.travellersListTitle}
        actions={
          <>
            <button
              type="button"
              className="nbtn"
              onClick={() => navigate('/admin/travellers/import')}
            >
              <i className="pi pi-users" style={{ fontSize: 14 }} />
              {t.importTravellers}
            </button>
            <button
              type="button"
              className="nbtn nbtn--primary"
              onClick={() => navigate('/admin/travellers/new')}
            >
              <i className="pi pi-plus" style={{ fontSize: 14 }} />
              {t.createNew}
            </button>
          </>
        }
      />

      <div className="ncard admin-table-card" style={{ padding: 0 }}>
        <div className="ncard__head">
          <div className="ncard__ico">
            <i className="pi pi-id-card" style={{ fontSize: 16 }} />
          </div>
          <div>
            <h3 className="ncard__title">{t.travellersListTitle}</h3>
          </div>
        </div>
        <DataTable
          style={{ width: '100%' }}
          filterDisplay="row"
          sortField="createdAt"
          sortOrder={-1}
          className="TableSignatures ntable"
          value={travellers}
          emptyMessage={t.noTravellerFound}
          responsiveLayout="scroll"
          paginator
          rows={10}
        >
          <Column
            field="pid"
            {...columnProps('PID')}
            body={({ pid }) => (
              <span
                style={{
                  fontFamily: 'var(--font-mono)',
                  fontSize: 11.5,
                  color: 'var(--ink-700)',
                  fontWeight: 600
                }}
              >
                {pid}
              </span>
            )}
          />
          <Column field="email" {...columnProps('Email')} />
          <Column
            field="phone"
            {...columnProps(t.phone)}
            body={({ phone }) => (
              <span style={{ fontFamily: 'var(--font-mono)', fontSize: 13 }}>{phone}</span>
            )}
          />
          <Column
            field="client.name"
            {...columnProps(t.client)}
            body={({ client }) => (
              <span className="nbadge" style={{ fontFamily: 'var(--font-mono)' }}>
                {client?.name}
              </span>
            )}
          />
          <Column
            field="createdAt"
            {...columnProps(t.creationDate)}
            body={({ createdAt }) => (
              <span className="ntable__meta">{new Date(createdAt).toLocaleDateString()}</span>
            )}
          />
          <Column
            style={{ width: 140, textAlign: 'right' }}
            {...actionsColumnProps}
            body={({ id }) => (
              <AdminTableActions
                id={id}
                editPath="/admin/travellers/"
                onDelete={deleteTraveller}
                deleteHeader={t.deleteTravellerHeader}
                deleteMessage={t.deleteTravellerMessage}
              />
            )}
          />
        </DataTable>
      </div>
    </>
  )
}
